import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if(to.path.indexOf('/wxComPlaint') != -1 ){
    // if(to.path == '/wxComPlaint'){
    document.title = to.meta.title || "微信投诉";
    next();
  }else{
    document.title = "管理系统";
    if (getToken()) {
      if (to.path === '/login') {
        next({ path: '/' })
        NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
      } else {
        if (store.getters.roles.length === 0) {
          store.dispatch('GetInfo').then(res => { // 拉取用户信息
            let menus=res.data.menus;
            let username=res.data.username;
            sessionStorage.setItem("isDefault",res.data.isDefault)
            sessionStorage.setItem("export",res.data.export)
            sessionStorage.setItem("type",res.data.type)
            sessionStorage.setItem("nickName",res.data.nickName)
            sessionStorage.setItem("adminId",res.data.adminId)
            sessionStorage.setItem("username",res.data.username)
            sessionStorage.setItem("changePass",res.data.changePass)
            if (res.data.otherInfo) {
              try {
                sessionStorage.setItem("otherInfo", window.atob(res.data.otherInfo))
              } catch (error) {
                sessionStorage.removeItem("otherInfo")
              }
            } else {
              sessionStorage.removeItem("otherInfo")
            }
            if (res.data.alarmInfo) {
              sessionStorage.setItem("alarmInfo", res.data.alarmInfo)
            } else {
              sessionStorage.removeItem("alarmInfo")
            }
            store.dispatch('GenerateRoutes', { menus,username }).then(() => { // 生成可访问的路由表
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              let routerArr = store.getters.addRouters;
              let curRouter = routerArr[0].children[0];
              console.log("11111112222222",store.getters.addRouters,"oooooo",to,curRouter)
              if(curRouter){
                next({...curRouter,replace: true})
              }else{
                next({ ...to, replace: true })
              }
            })
          }).catch((err) => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          })
        } else {
          next()
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next('/login')
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js